/**
 * navBarConstants.js
 *
 * Константы бокового меню. Вынесены отдельно, потому что MIN_WIDTH_FOR_MENU
 * импортируется не только из NavBar, но и из GamesPage, SearchBar и др.
 */

/** Ширина экрана (px), с которой показываем desktop-sidebar слева, а не burger-menu. */
export const MIN_WIDTH_FOR_MENU = 1366;

/**
 * Сколько последних пунктов меню держим внизу sidebar (после реферальной карточки).
 * Сейчас: «Поддержка» и «Выйти» — см. menuRouteList в Routes.js.
 */
export const BOTTOM_MENU_ITEMS_COUNT = 2;
